// src/Pages/SharedLayout.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, m } from "framer-motion";

const pageVariants = {
  initial: { opacity: 0 },
  in: { opacity: 1 },
  out: { opacity: 0 },
};

const pageTransition = {
  type: "tween",
  ease: "easeInOut",
  duration: 0.35,
};

const SharedLayout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div className="pl-[290px] md:pl-0 bg-white overflow-x-hidden relative w-full max-w-full min-w-0">
      <AnimatePresence mode="wait">
        <m.div
          key={location.pathname}
          initial="initial"
          animate="in"
          exit="out"
          variants={pageVariants}
          transition={pageTransition}
          className={`relative min-w-0 ${
            isHomePage
              ? "bg-[#223bac] min-h-screen overflow-hidden"
              : "bg-white min-h-screen"
          }`}
        >
          {isHomePage ? (
            <div className="!m-0 !p-0 !w-full !h-full overflow-hidden min-w-0">{children}</div>
          ) : (
            <div className="inner-page-wrap !m-0 !p-0 !w-full min-w-0">{children}</div>
          )}
        </m.div>
      </AnimatePresence>
    </div>
  );
};

export default SharedLayout;
